import { basicColors, retroColors, electricColors } from "../../../style/basic/basicColors";
export const allMemberStyle = {
  tableHeading: {
    default: {
      margin: "5px 0px 5px",
      color: basicColors.first,
    },
    retro: {
      margin: "5px 0px 5px",
      color: "var(--second)",
      fontWeight: 600,
    },
    electric: {
      margin: "5px 0px 5px",
      color: electricColors.second,
      fontWeight: 600,
    },
  },
  userHeading: {
    default: {
      color: basicColors.first,
      fontSize: "14px",
      paddingBottom: "1em",
    },
    retro: {
      color: "var(--second)",
      fontSize: "14px",
      paddingBottom: "1em",
    },
    electric: {
      color: electricColors.second,
      fontSize: "14px",
      paddingBottom: "1em",
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Team/styles/allMemberStyle.js